import { TreeItem } from '../component/controls/tree/tree.component';
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'treeFilter',
    standalone: false
})
export class TreeFilterPipe implements PipeTransform {

    transform(items: TreeItem[], filter: any): TreeItem[] {
        if (!items || !filter || filter.name.value == '') {
            return items;
        }
        return items.filter(item => item.name.toLowerCase().indexOf(filter.name.value.toLowerCase()) !== -1);
    }
}
